export class SliderAutoplay {
    constructor() {
        this.timer = null;
        this.startTime = 0;
        this.isPausedByMouse = false;
        this.totalPauseTime = 0;
        this.pauseStartTime = 0;
        this.slideDuration = 4000; // 4 seconds per slide
    }

    start(slideIndex, totalSlides, onProgress, onSlideChange) {
        this.stop();
        
        // Reset pause tracking for new slide
        this.totalPauseTime = 0;
        this.pauseStartTime = 0;
        
        this.startTime = Date.now();
        this.timer = setInterval(() => {
            if (!this.isPausedByMouse) {
                const elapsed = Date.now() - this.startTime - this.totalPauseTime;
                const progressPercent = (elapsed / this.slideDuration) * 100;
                
                if (progressPercent >= 100) {
                    // Time to go to next slide
                    if (onSlideChange) {
                        onSlideChange();
                    }
                } else {
                    // Update loader progress
                    if (onProgress) {
                        onProgress(progressPercent);
                    }
                }
            }
        }, 16); // ~60fps
    }

    stop() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    pause() {
        if (this.timer) {
            this.isPausedByMouse = true;
            this.pauseStartTime = Date.now();
        }
    }

    resume() {
        if (this.isPausedByMouse) {
            const pauseDuration = Date.now() - this.pauseStartTime;
            this.totalPauseTime += pauseDuration;
            this.isPausedByMouse = false;
        }
    }
}

export function updateActiveTab(navItems, activeIndex) {
    navItems.forEach((item, index) => {
        if (index === activeIndex) {
            item.classList.add('-active');
        } else {
            item.classList.remove('-active');
        }
    });
}

export function startLoaderAnimation(loaders, slideIndex) {
    // Reset all loaders
    loaders.forEach((loader, index) => {
        if (loader) {
            loader.classList.remove('-active');
            loader.style.setProperty('--loader-width', '0%');
        }
    });
    
    // Start animation for current slide
    const currentLoader = loaders[slideIndex];
    if (currentLoader) {
        currentLoader.classList.add('-active');
        currentLoader.style.setProperty('--loader-width', '0%');
    }
}

export function updateLoaderProgress(loader, progressPercent) {
    if (loader && loader.classList.contains('-active')) {
        // Clamp progress between 0 and 100
        const clampedProgress = Math.max(0, Math.min(100, progressPercent));
        loader.style.setProperty('--loader-width', `${clampedProgress}%`);
    }
}